<template>
<DataVariantManage v-if="isNewVariantPage" :params="params" :index="index" :active="active" />
<div class="content" v-else-if="!loading">
    <section class="gen-form-container">
      <div class="edit-header">
        <Tabs :tabs="dataConfig.form" v-model:activeTab="activeTab"/>
        <Localizations v-model="localizations" :fieldDesc="fieldDesc" :itemLocalizations="item?._localizations" @removeVariant="removeVariant" />
        <div class="actions">
          <button class="btn btn-success" @click.prevent="save"><i class="fas fa-check"></i> Sačuvaj</button>
          <button class="btn btn-danger" @click.prevent="doRemove" v-if="!dataConfig.noDelete"><i class="fa fa-trash" aria-hidden="true"></i> Ukloni
</button>
        </div>
      </div>
      <form class="gf-row">
        <DataForm :item="item" :params="params" :localizations="localizations" :autoSlug="autoSlug" :activeTab="activeTab"/>
        <!--<div class="actions">

        </div>-->
      </form>
    </section>
</div>
</template>

<script>
import api from '@/Util/api';
import slug from '@/Util/slug';
import localizations from '@/Mixins/localizations';

var fieldTypeMap={
  text: ["textauto"],
  longtext: ["textauto"],
  mediumtext: ["textauto"],
  email: ["input", {type: "email"}],
  'int(1)': ["checkbox"],
  'relUuid': ["relOne"],
  'relManyUuid': ["relMany"],
};

export default {
  mixins: [localizations],
  props: ["params", "index", "active"],
  data: ()=>({
    loading: true,
    item: null,
    localizations: {},
    doAutoSlug: false,
    activeTab: null,
  }),
  computed: {
    isNewVariantPage() {
      if (this.params?.type!="Product")
        return false;
      return this.params.id==api.nullUuid && this.$route.query.parent;
    },
    dataConfig() {
      return this.stores.config.config?.data?.[this.params?.type];
    },
    fieldDesc() {
      return this.stores.auth.typeDesc?.[this.params?.type] ?? {};
    },
    autoSlug() {
      var localization=this.currentLocalization(this.fieldDesc?.slug?.localize || []);
      if (localization) {
        var source=localization.name || localization.title || "";
        return slug(source, 'url')
      }
      return "";
    },
  },
  watch: {
    autoSlug() {
      if (this.doAutoSlug) {
        var localization=this.currentLocalization(this.fieldDesc?.slug?.localize || []);
        if (localization)
          localization.slug=this.autoSlug;
      }
    },
  },
  methods: {
    currentLocalization(localizationFields) {
      if (!this.item)
        return null;
      var localizationType=localizationFields.join("|");
      var localization=localizationFields.map(field=>this.localizations[field] || "").join("|");
      if (!this.item._localizations)
        this.item._localizations={};
      if (!this.item._localizations[localizationType])
        this.item._localizations[localizationType]={};
      if (!this.item._localizations[localizationType][localization])
        this.item._localizations[localizationType][localization]={};

      return this.item._localizations[localizationType][localization];
    },
    async loadItem() {
      if (this.params.id==api.nullUuid) {
        this.item=api.create(this.params.type);
        if (this.$route.query.parent)
          this.item.parent=this.$route.query.parent;
        this.doAutoSlug=true;

        // auto set klijent if field exists
        if (this.stores.auth.typeDesc?.[this.params.type]?.klijent?.type=="relUuid");
          this.item.klijent=this.stores.auth.currentClient;
      } else {
        this.item=(await api.get(this.params.type, this.params.id));
      }
      if (this.item) {
        this.loading=false;
        var itemTitle=this.item.name || this.item.title || this.item.username || "";
        if (this.params.id==api.nullUuid)
          itemTitle="Novo";
        this.stores.page.replace(""+itemTitle, this.params.path, this.stackIndex);
        this.pageLink=this.stores.page.stack[this.stackIndex];
        this.activeTab=this.dataConfig.form[0].id;
      }
    },
    async save() {
      var nonLocalizedFields=[];
      var localizations={};
      for(var section of this.dataConfig.form) {
        // console.log(section);
        for(var group of (section.fields?[section]:section.groups) || [])
        for(var field of group.fields) {
          var apiField=this.fieldDesc[field.id] || {};
          if (field.component=='FormPageSlug')
            nonLocalizedFields.push("target");
          if (!apiField.localize) {
            nonLocalizedFields.push(field.id);
          } else {
            var localizationType=apiField.localize.join("-");
            localizations[localizationType]=localizations[localizationType] || [];
            localizations[localizationType].push(field.id);
          }
        }
      }
      if (this.item.parent)
        nonLocalizedFields.push("parent");

      await this.item?.saveNoUpdate?.("{"+nonLocalizedFields.join(",")+"}");

      for(var locType in localizations) {
        var locTypeSplit=locType.split("|");
        for(var localization in this.item._localizations[locType]) {
          var locData=this.item._localizations[locType][localization];
          var localizationSplit=localization.split("|");
          locData=this.item.filterFields(locData, "{"+localizations[locType].join(",")+"}");
          var locVal={};
          for(var i in locTypeSplit)
            locVal[locTypeSplit[i]]=localizationSplit[i] || "";
          await api.doUpdate(this.params?.type, this.item.uuid, locData, false, locVal);
        }
      }

      this.$router.go(-1);
    },
    async doRemove() {
      if (!confirm("Are you sure?"))
        return;
      await this.item?.delete?.();
      this.$router.go(-1);
    },
    removeVariant({localization, value}) {
      this.localizations[localization]=null;
      delete this.item._localizations[localization][value];
    },
  },
  created() {
    this.stackIndex=this.stores.page.pushPage("...", this.params.path, this.index);
    this.pageLink=this.stores.page.stack[this.stackIndex];
//     =this.stores.page.pushPage("...", this.params.path);
//     this.$nextTick(()=>this.stackIndex=this.stores.page.pushPage("...", this.params.path));
    this.loadItem();
  },
  unmounted() {
    this.stores.page.popPage(this.pageLink);
  },

}
</script>
